import { getFixedPlaces } from "./get-fixed-places";

export const snapNumber = (value: number, roundingFactor: number) => {
	const fixedPlaces = getFixedPlaces(value);
	return +(Math.round(value / roundingFactor) * roundingFactor).toFixed(
		fixedPlaces,
	);
};
